import { Navigate, useLocation } from "react-router-dom";
import type { ReactNode } from "react";

import {
  selectIsAuthenticated,
  selectNeedsTenant,
  useAuthStore,
} from "../stores/auth";

type Props = {
  children: ReactNode;
  /** Si true, exige qu'un tenant soit sélectionné (pour les pages métier). */
  requireTenant?: boolean;
};

export function ProtectedRoute({ children, requireTenant = true }: Props) {
  const isAuth = useAuthStore(selectIsAuthenticated);
  const needsTenant = useAuthStore(selectNeedsTenant);
  const location = useLocation();

  if (!isAuth) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (requireTenant && needsTenant) {
    return <Navigate to="/select-tenant" replace />;
  }
  return <>{children}</>;
}
